import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";

import { PageLayout } from "./components/navigation/0_PageLayout";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { UserProvider } from "./contexts/userContext.js";
import { ErrorProvider } from "./contexts/errorContext.js";

/**
 * msal-react is built on the React context API and all parts of your app that require authentication must be 
 * wrapped in the MsalProvider component. You will first need to initialize an instance of PublicClientApplication 
 * then pass this to MsalProvider as a prop. All components underneath MsalProvider will have access to the 
 * PublicClientApplication instance via context as well as all hooks and components provided by msal-react. For more, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const App = ({ instance }) => {
  return (
    <BrowserRouter>
        <MsalProvider instance={instance}>
          <ErrorProvider>
          <UserProvider>
            <PageLayout />
          </UserProvider>
          </ErrorProvider>
      </MsalProvider>
    </BrowserRouter>
  );
}

export default App;